import React from "react";
import { Link } from "react-router-dom";

export type PromoTourCardVariant = "compact" | "grid" | "stacked";

const toTitleCase = (value: string): string =>
  value.toLowerCase().replace(/(^|\s)\S/g, (char) => char.toUpperCase());

export interface PromoTourCardProps {
  image: string;
  title: string;
  brandLogo?: string;
  ribbon?: string;
  destination?: string;
  departFrom?: string;
  guaranteed?: boolean;
  originalPrice?: string;
  save?: string;
  price: string;
  priceSuffix?: string;
  footnote?: string;
  href?: string;
  variant?: PromoTourCardVariant;
}

export default function PromoTourCard({
  image,
  title,
  brandLogo,
  ribbon,
  destination,
  departFrom,
  guaranteed,
  originalPrice,
  save,
  price,
  priceSuffix = "/ person",
  footnote,
  href,
  variant = "compact",
}: PromoTourCardProps) {
  const content = (
    <>
      <div className="v2-offer-card__media">
        <img src={image} alt={title} />
        {ribbon && <span className="v2-offer-card__badge">{ribbon}</span>}
        {brandLogo && <img className="v2-offer-card__brand" src={brandLogo} alt="Brand" />}
      </div>
      <div className="v2-offer-card__body">
        {(destination || departFrom) && (
          <div className="v2-offer-card__loc">
            {destination && toTitleCase(destination)}
            {destination && departFrom && <span className="v2-offer-card__dot">•</span>}
            {departFrom && <span>from {departFrom}</span>}
          </div>
        )}
        <h3 className="v2-offer-card__title">{title}</h3>
        {guaranteed && <span className="v2-offer-card__tag">Guaranteed Departure</span>}
        <div className="v2-offer-card__pricing">
          <span className="v2-offer-card__from">
            From {originalPrice && <span className="v2-offer-card__orig">{originalPrice}</span>}
          </span>
          {save && <span className="v2-offer-card__save-tag">Save {save}</span>}
        </div>
        <div className="v2-offer-card__price">
          {price} <span>{priceSuffix}</span>
        </div>
        {footnote && <div className="v2-offer-card__footnote">{footnote}</div>}
      </div>
    </>
  );

  const className = `v2-offer-card v2-offer-card--${variant}`;

  return href ? (
    <Link to={href} className={className}>
      {content}
    </Link>
  ) : (
    <div className={className}>{content}</div>
  );
}
